import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiCheckCircle } from 'react-icons/fi';
import api from '../services/api';
import './Cadastro.css';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erroRede, setErroRede] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setErroRede('Informe seu e-mail.');
      return;
    }
    setLoading(true);
    setErroRede('');
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setEnviado(true);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('[EsqueciSenha]', err);
      // Resposta do servidor (4xx/5xx) -> não revela se o e-mail existe.
      // Sem resposta = falha de rede real -> avisa o usuário.
      if (err.response) {
        setEnviado(true);
      } else {
        setErroRede('Não foi possível conectar ao servidor. Verifique sua conexão e tente de novo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro-page">
      <form className="cadastro-card" onSubmit={handleSubmit} style={{ maxWidth: 420 }}>
        <div className="cadastro-logo">
          <h1>LicitaPRO</h1>
        </div>
        <p className="cadastro-subtitle">Recuperar acesso</p>

        {enviado ? (
          <div style={{ textAlign: 'center', padding: '16px 8px' }}>
            <FiCheckCircle size={42} color="#00874a" />
            <h3 style={{ margin: '12px 0 8px', color: '#1a202c' }}>Tudo certo!</h3>
            <p style={{ color: '#555', fontSize: '0.92rem', margin: 0 }}>
              Se o e-mail <strong>{email}</strong> estiver cadastrado, em instantes você
              receberá um link para redefinir sua senha.
            </p>
            <p style={{ color: '#777', fontSize: '0.82rem', marginTop: 16 }}>
              Não recebeu? Verifique a caixa de spam ou entre em contato com o suporte.
            </p>
          </div>
        ) : (
          <>
            <p style={{ color: '#555', fontSize: '0.88rem', margin: '0 0 18px', textAlign: 'center' }}>
              Informe o e-mail da sua conta e enviaremos as instruções para redefinir
              sua senha.
            </p>

            {erroRede && (
              <div
                role="alert"
                style={{
                  background: '#fef2f2',
                  color: '#b91c1c',
                  padding: '10px 12px',
                  borderRadius: 8,
                  fontSize: '0.86rem',
                  marginBottom: 14,
                }}
              >
                {erroRede}
              </div>
            )}

            <div className="cadastro-field">
              <label htmlFor="email">E-mail</label>
              <div className="cadastro-input-wrap">
                <input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                  required
                  autoComplete="email"
                  style={{ paddingLeft: 38 }}
                />
                <FiMail
                  style={{
                    position: 'absolute',
                    left: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#777',
                  }}
                />
              </div>
            </div>

            <button className="cadastro-btn" type="submit" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar link de recuperação'}
            </button>
          </>
        )}

        <p className="cadastro-rodape">
          <Link to="/login">← Voltar para o login</Link>
        </p>
      </form>
    </div>
  );
}
